import dayjs, { Dayjs } from "dayjs";
import { FilterValue } from "../../Filters/FilterValue";
export interface NPSAnalyticsFilters {
  order_type: FilterValue[] | null;
  pm_admin_id: FilterValue[] | null;
  start_date: Dayjs;
  end_date: Dayjs;
}

export interface NPSAnalyticsSelectedFilters {
  order_type: FilterValue[] | null;
  pm_admin_id: FilterValue[] | null;
  start_date: string;
  end_date: string;
}

export interface NPSAnalyticsAPIFilters {
  order_type: FilterValue[] | null;
  pm_admin_id: FilterValue[] | null;
  start_date: string;
  end_date: string;
}

export function parseQueryParamsForNPSAnalyticsFilters(
  params: NPSAnalyticsFilters | null,
  query_params: URLSearchParams
): NPSAnalyticsFilters {
  const currentDate = dayjs().startOf("day");
  const previousMonthDate = currentDate.startOf("month");

  return {
    order_type: params?.order_type ?? [],
    pm_admin_id: params?.pm_admin_id ?? [],
    start_date: query_params.get("start_date")
      ? dayjs(query_params.get("start_date"), "YYYY-MM-DD")
      : previousMonthDate,
    end_date: query_params.get("end_date")
      ? dayjs(query_params.get("end_date"), "YYYY-MM-DD")
      : currentDate,
  };
}
